import './UnderlineNav-0c1e0dff.css';

var classes = {"UnderlineNav":"prc-UnderlineNav-UnderlineNav-4E9Yr","UnderlineNav--right":"prc-UnderlineNav-UnderlineNav--right-Trs9C","UnderlineNavItem":"prc-UnderlineNav-UnderlineNavItem-nmHMS","UnderlineNavActions":"prc-UnderlineNav-UnderlineNavActions-onc2h","UnderlineNav--full":"prc-UnderlineNav-UnderlineNav--full-kE3kc","UnderlineNavBody":"prc-UnderlineNav-UnderlineNavBody-bh1JN","UnderlineNavLink":"prc-UnderlineNav-UnderlineNavLink-7BXiO"};

export { classes as default };
